import { deviceType } from "../constants/general.constant";

const getDeviceType = () => {
  const width = window.innerWidth;

  if (width <= 767) return deviceType.mobile;
  if (width <= 1024) return deviceType.tablet;
  return deviceType.desktop;
};

export default getDeviceType;